import React, { useState, useRef, useEffect } from "react";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./photo-gallery-enhanced.css";

const VenueTopMediaPhotoGallery = ({
  open,
  mediaList,
  onClose,
  venueName,
  selectedIndex,

  onEndReached,
}) => {
  const [photos, setPhotos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(selectedIndex);
  const galleryRef = useRef(null);

  useEffect(() => {
    setCurrentIndex(selectedIndex);
  }, [selectedIndex]);

  useEffect(() => {
    if (photos.length > 0 && currentIndex >= photos.length - 1) {
      onEndReached?.();
    }
  }, [currentIndex, photos]);

  useEffect(() => {
    const formatted = mediaList?.map((media, idx) => ({
      id: idx,
      original: media.mediaUrl,
      thumbnail: media.thumbnailMediaUrl,
      mediaType: media.mediaType,
      duration: media.duration,
    }));
    setPhotos(formatted);
  }, [mediaList]);

  const handleSlide = (currentIndex) => {
    setCurrentIndex(currentIndex);
    const slides = document.querySelectorAll(".image-gallery-slide video");
    slides.forEach((video, idx) => {
      if (video && idx !== currentIndex) {
        video.pause();
        video.currentTime = 0;
      }
    });
    const currentVideo = slides[currentIndex];
    if (currentVideo) {
      setTimeout(() => {
        currentVideo.play().catch((err) => {
          console.warn("Video play error:", err);
        });
      }, 0);
    }
  };

  const renderItem = (item) => {
    if (item.mediaType === "Video") {
      return (
        <div
          style={{
            width: "100%",
            height: "50vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <video
            src={item.original}
            style={{ maxHeight: "100%", maxWidth: "100%", borderRadius: 8 }}
            controls
          />
          {item.duration && (
            <Box
              sx={{
                position: "absolute",
                bottom: 8,
                right: 8,
                backgroundColor: "rgba(0,0,0,0.6)",
                color: "#fff",
                px: 1,
                py: 0.3,
                borderRadius: 1,
                fontSize: 12,
              }}
            >
              {item.duration}
            </Box>
          )}
        </div>
      );
    } else {
      return (
        <div
          style={{
            width: "100%",
            height: "50vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={item.original}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              borderRadius: 8,
              objectFit: "cover",
              border: "1px solid #ddd",
            }}
          />
        </div>
      );
    }
  };

  const renderThumbInner = (item) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 6,
          overflow: "hidden",
          border: "2px solid transparent",
          transition: "border 0.2s",
          position: "relative",
        }}
      >
        <img
          src={item.thumbnail}
          alt="thumb"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        {item.mediaType === "Video" && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              fontSize: 18,
              pointerEvents: "none",
            }}
          >
            ▶
          </Box>
        )}
      </div>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        sx: {
          width: "60%",
          height: "75%",
          maxWidth: "70%",
          overflow: "hidden",
          borderRadius: 3,
          background: "#fff",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          height: 70,
          px: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #eee",
        }}
      >
        <Typography fontSize={21} fontWeight={600}>
          {venueName}
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{ background: "#f2f2f2", "&:hover": { background: "#e0e0e0" } }}
        >
          <Close />
        </IconButton>
      </Box>

      <Box sx={{ p: 2 }}>
        <ImageGallery
          ref={galleryRef}
          items={photos}
          showPlayButton={false}
          showFullscreenButton={false}
          autoPlay={false}
          startIndex={selectedIndex}
          showThumbnails={true}
          showIndex={true}
          thumbnailPosition="bottom"
          slideDuration={300}
          renderItem={renderItem}
          renderThumbInner={renderThumbInner}
          onSlide={handleSlide}
        />
      </Box>
    </Dialog>
  );
};

export default VenueTopMediaPhotoGallery;
